import { z } from "zod";

export const registerNewUserSchema = z
  .object({
    email: z
      .string()
      .min(1, { message: "Unos email adrese je obavezan" })
      .email({ message: "Nevalidan format email adrese" }),
    password: z
      .string({ message: "Unos šifre je obavezan" })
      .min(5, { message: "Šifra mora imati minimalno 5 karaktera" }),
    confirmPassword: z
      .string({ message: "Unos šifre je obavezan" })
      .min(5, { message: "Šifra mora imati minimalno 5 karaktera" }),
    firstName: z.string({ message: "Unos imena korisnika je obavezan" }),
    lastName: z.string({ message: "Unos prezimena korisnika je obavezan" }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Šifra moraju da se podudaraju",
    path: ["confirmPassword"],
  });

export type RegisterFormData = z.infer<typeof registerNewUserSchema>;
